import {Box, List, Paper, TextField} from "@mui/material";
import React, {ChangeEventHandler, KeyboardEventHandler, useContext, useEffect, useState} from "react";
import {FirebaseContext} from "../firebase/FirebaseProvider";
import {connect} from "react-redux";
import {selectNetwork, selectRevisions} from "../../redux/selectors/firebase";
import {NetworkData} from "../../fstn/network";
import makeStyles from "@mui/styles/makeStyles";
import {Revision} from "./Revision";

const useStyles = makeStyles((theme) => ({
    columnDate: {
        width: 160
    },
    columnKey: {
        width: 320,
        overflowX: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    columnName: {
        flexGrow: 1
    },
    content: {
        height: "100%",
        margin: theme.spacing(2),
        width: "calc(100% - 32px)"
    },
    header: {
        display: "flex",
        flexGrow: 1,
        margin: theme.spacing(1),
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(2)
    },
    list: {
        height: "calc(100% - 110px)",
        overflowX: "hidden",
        overflowY: "auto",
        '&::-webkit-scrollbar': {
            marginLeft: 4,
            width: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: '0.4em'
        }
    }
}));

interface IEntity {
    m_entity: {m_components: string[]}
    m_name?: {m_contents: string}
    m_text?: {text: string}
}
export interface IVersionData {
    blocks: {m_blockName: string}[]
    entities: IEntity []
}
export interface IVersion {
    created: number
    data: IVersionData
    message: string
    user: string
}
interface IRevisions {
    network: NetworkData
    project: string
    revisions: {[key: string]: {[key: string]: IVersion}}
}
function Revisions({network, project, revisions}: IRevisions) {
    const classes = useStyles();
    const [changingCreated, setChangingCreated] = useState("");
    const [changingKey, setChangingKey] = useState("");
    const [changingName, setChangingName] = useState("");
    const [created, setCreated] = useState("");
    const [expandedState, setExpandedState] = useState("");
    const [key, setKey] = useState("");
    const [name, setName] = useState("");
    const {track, untrack} = useContext(FirebaseContext);
    const handleCreatedBlur = () => setCreated(changingCreated);
    const handleCreatedChange: ChangeEventHandler<HTMLInputElement> = ({target}) => setChangingCreated(target.value);
    const handleCreatedKeyDown: KeyboardEventHandler<HTMLInputElement> =
        ({key}) => key === "Enter" && setCreated(changingCreated);
    const handleKeyBlur = () => setKey(changingKey);
    const handleKeyKeyDown: KeyboardEventHandler<HTMLInputElement> =
        ({key}) => key === "Enter" && setKey(changingKey);
    const handleKeyChange: ChangeEventHandler<HTMLInputElement> = ({target}) => setChangingKey(target.value); 
    const handleNameBlur = () => setName(changingName); 
    const handleNameChange: ChangeEventHandler<HTMLInputElement> = ({target}) => setChangingName(target.value); 
    const handleNameKeyDown: KeyboardEventHandler<HTMLInputElement> =
        ({key}) => key === "Enter" && setName(changingName);

    useEffect(() => {
        track(`revisions/${project}`, ["revisions"]);
        track("users", ["users"]);

        return () => {
            untrack(`revisions/${project}`);
            untrack("users");
        }
    }, [project, track, untrack]);

    return (
        <Box className={classes.content}>
            <Paper>
                <Box className={classes.header}>
                    <TextField className={classes.columnName} label="State Name"
                               onChange={handleNameChange} onBlur={handleNameBlur} onKeyDown={handleNameKeyDown}
                               size="small" sx={{margin: 1}} value={changingName}/>
                    <TextField className={classes.columnKey} label="State Key"
                               onChange={handleKeyChange} onBlur={handleKeyBlur} onKeyDown={handleKeyKeyDown}
                               size="small" sx={{margin: 1}} value={changingKey}/>
                    <TextField className={classes.columnDate} label="Created"
                               onChange={handleCreatedChange} onBlur={handleCreatedBlur} onKeyDown={handleCreatedKeyDown}
                               size="small" sx={{margin: 1}} value={changingCreated}/>
                </Box>
            </Paper>
            <List className={classes.list} dense>
                {Object.entries(revisions)
                    .filter(([stateKey, revision]) =>
                        (key === "" || stateKey.includes(key)) &&
                        (name === "" || (network.states[stateKey] && network.states[stateKey].name.includes(name))) &&
                        (created === "" || (Object.values(revision).length &&
                            new Date(Object.values(revision)[0].created * 1000).toLocaleString().includes(created)))
                    )
                    .map(([stateKey, versions]) => 
                        <Revision expanded={expandedState} key={stateKey} project={project}
                                  setExpanded={setExpandedState} state={network.states[stateKey]} stateKey={stateKey}
                                  versions={versions}/>
                    )}
            </List>
        </Box>
    );
}
const mapStateToProps = (store: never) => ({
    network: selectNetwork(store),
    revisions: selectRevisions(store) || {}
});

const connected = connect(mapStateToProps, {
})(Revisions);

export {connected as Revisions};